import { render, staticRenderFns } from "./AlphaProjectSection.vue?vue&type=template&id=d1551f4c&scoped=true&"
import script from "./AlphaProjectSection.vue?vue&type=script&lang=js&"
export * from "./AlphaProjectSection.vue?vue&type=script&lang=js&"
import style0 from "./AlphaProjectSection.vue?vue&type=style&index=0&id=d1551f4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1551f4c",
  null
  
)

export default component.exports